export default "https://static-service.opploans-assets.com/assets/webpack/da7c543d9959c5032b01b205f6c47b29.png";